import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import shareIcon from '../../assets/img/share.svg'
import closeIcon from '../../assets/img/close.svg'
import facebookIcon from '../../assets/img/facebook.svg'
import twitterIcon from '../../assets/img/twitter.svg'
import emailIcon from '../../assets/img/email.svg'
import smsIcon from '../../assets/img/sms.svg'

import './ShareButton.scss'

export default class ShareButton extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isEnabled: false
    }
  }

  componentDidMount () {
    // this.props.setShareButtonsVisible(0)
  }

  handleMainButtonClick = () => {
    if (this.state.isEnabled) {
      this.props.setShareButtonsVisible(0)
    } else {
      this.props.setShareButtonsVisible(1)
    }
    this.setState({ isEnabled: !this.state.isEnabled })
  }

  goToUrl (url) {
    if (url) {
      window.location.href = url
    }
  }

  render () {
    const { facebook, twitter, email, phone, shareTitle, shareSubtitle } = this.props
    return (
      <CSSTransitionGroup
        transitionName='ou_share'
        transitionEnterTimeout={750}
        transitionLeaveTimeout={750}
      >
        <div id='ou_share__main-button' className='ou_share__main-button' onClick={this.handleMainButtonClick}>
          <CSSTransitionGroup
            transitionName='ou_share'
            transitionEnterTimeout={750}
            transitionLeaveTimeout={750}
          >
            {(this.state.isEnabled)
              ? <div className='ou_share__main-button-icon-close' style={{ backgroundImage: `url(${closeIcon})` }} key={0} />
              : <div className='ou_share__main-button-icon-share' style={{ backgroundImage: `url(${shareIcon})` }} key={1} />
            }
          </CSSTransitionGroup>
        </div>

        {/*{this.state.isEnabled &&*/}
        {/**/}
        {/*}*/}
        <div className={`ou_share ou_share__bg ${this.state.isEnabled ? 'ou_share__in' : 'ou_share__out'}`} key='share'>
          <div id='ou_share__title' className='ou_share__title'>{shareTitle}</div>
          <div id='ou_share__subtitle' className='ou_share__subtitle'>{shareSubtitle}</div>
          <div className='ou_share__buttons'>
            <div id='ou_share__button--facebook' className='ou_share__button ou_share__button--facebook' onClick={() => this.goToUrl(facebook)}>
              <div className='ou_share__button-icon' style={{ backgroundImage: `url(${facebookIcon})` }} />
            </div>
            <div id='ou_share__button--twitter' className='ou_share__button ou_share__button--twitter' onClick={() => this.goToUrl(twitter)}>
              <div className='ou_share__button-icon' style={{ backgroundImage: `url(${twitterIcon})` }} />
            </div>
            <div id='ou_share__button--email' className='ou_share__button ou_share__button--email' onClick={() => this.goToUrl(`mailto:${email}`)}>
              <div className='ou_share__button-icon' style={{ backgroundImage: `url(${emailIcon})` }} />
            </div>
            <div id='ou_share__button--sms' className='ou_share__button ou_share__button--sms' onClick={() => this.goToUrl(`sms:${phone}`)}>
              <div className='ou_share__button-icon' style={{ backgroundImage: `url(${smsIcon})` }} />
            </div>
          </div>
        </div>
      </CSSTransitionGroup>
    )
  }

  static propTypes = {
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    shareTitle: PropTypes.string,
    shareSubtitle: PropTypes.string,
    setShareButtonsVisible: PropTypes.func
  }
}



// WEBPACK FOOTER //
// ./src/templates/outSide/components/shareButton/ShareButton.js